/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Stat_Total_DistanceInputs */

const en_ui_stat_total_distance = /** @type {(inputs: Ui_Stat_Total_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Distance`)
};

const de_ui_stat_total_distance = /** @type {(inputs: Ui_Stat_Total_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanz`)
};

/**
* | output |
* | --- |
* | "Total Distance" |
*
* @param {Ui_Stat_Total_DistanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_stat_total_distance = /** @type {((inputs?: Ui_Stat_Total_DistanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Stat_Total_DistanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_stat_total_distance(inputs)
	return de_ui_stat_total_distance(inputs)
});